import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RequestedFieldValue } from "./requested-field-value"

/**
 * One row inside a `ResponseCard`: pairs a single requested `field` with this response's answer for it
 * (`values[field.id]`) and renders the read-only value host. Rendered per field via `<Repeat
 * pass="field">`, so it is a separate file rather than an inline closure. The response's `values` map
 * comes from the surrounding `<Bound values={...}>` (the card), avoiding prop drilling.
 *
 * @param {object} props
 * @param {{ id: string, type: string, label: string }} props.field
 */
export function RequestedFieldValueRow({ field }) {
    const { values } = useBoundContext()
    if (!field?.id) return null

    return <RequestedFieldValue field={field} value={getValue()} />

    function getValue() {
        return values ? values[field.id] : undefined
    }
}
